import { render, staticRenderFns } from "./SingleGPUCard.vue?vue&type=template&id=67669453&"
import script from "./SingleGPUCard.vue?vue&type=script&lang=js&"
export * from "./SingleGPUCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports